import { msg } from '@gonfalon/messages/msg';

// Blocklist: reject Unicode control characters (C0: U+0000–U+001F, DEL: U+007F, C1: U+0080–U+009F).
// oxlint-disable-next-line no-control-regex
export const EVENT_KEY_PATTERN = /^[^\u0000-\u001F\u007F\u0080-\u009F]*$/;
export const EVENT_KEY_MAX_LENGTH = 768;
export const EVENT_KEY_FIELD_NAME = 'eventKey';

/** Shared register options for the Event Key field used for creating new metrics. */
export const eventKeyRegisterOptions = () => ({
  maxLength: {
    value: EVENT_KEY_MAX_LENGTH,
    message: msg('metrics.eventKeyField.tooLong', { max: EVENT_KEY_MAX_LENGTH }),
  },
  pattern: {
    value: EVENT_KEY_PATTERN,
    message: msg('metrics.eventKeyField.controlCharacters'),
  },
});
